import { useOutletContext } from "react-router-dom";
import Hero from "../components/landing/Hero";
import GroomIQTeaser from "../components/landing/GroomIQTeaser";
import Transformations from "../components/landing/Transformations";
import BookingForm from "../components/landing/BookingForm";
import { HolidayBanner } from "../components/landing/HolidayDecor";
import { activeHoliday } from "../lib/holidays";

export default function HomePage() {
  const content = useOutletContext();
  const holiday = activeHoliday(content.settings);
  return (
    <>
      {holiday && <HolidayBanner theme={holiday} settings={content.settings} />}
      <Hero settings={content.settings} slides={content.slides} holiday={holiday} />
      <GroomIQTeaser />
      {content.settings.showBeforeAfter === true && <Transformations transformations={content.transformations} />}
      <BookingForm services={content.services} settings={content.settings} />
    </>
  );
}
